import { combineReducers } from '@reduxjs/toolkit';
import spinner from './spinnerSlice';

const reducer = combineReducers({
  spinner
});

export default reducer;
